import React, { createContext, useContext, useState, useCallback } from 'react';

export const AIAssistantContext = createContext();

export const AIAssistantProvider = ({ children }) => {
  const [aiPayloadGenerator, setAiPayloadGenerator] = useState(null);

  const registerPayloadGenerator = useCallback((generatorFn) => {
    setAiPayloadGenerator(() => generatorFn);
  }, []);

  const clearPayloadGenerator = useCallback(() => {
    setAiPayloadGenerator(null);
  }, []);

  const getPayload = useCallback(async () => {
    if (aiPayloadGenerator) {
      try {
        return await aiPayloadGenerator();
      } catch (error) {
        console.error("Error generating AI payload:", error);
        return null;
      }
    }
    return null;
  }, [aiPayloadGenerator]);

  return (
    <AIAssistantContext.Provider value={{ registerPayloadGenerator, clearPayloadGenerator, getPayload }}>
      {children}
    </AIAssistantContext.Provider>
  );
};

export const useAIAssistantContext = () => useContext(AIAssistantContext);
